<template>
  <div class="dl_k">
    <div class="main">
      <div class="dl_nk">
        <div class="zc_bt">用户注册</div>
        <div class="dl_n">
          <el-form
            ref="regForm"
            :rules="rules"
            :model="regForm"
            class="lgform_hz"
          >
            <el-form-item label="姓名：" prop="username">
              <el-input v-model="regForm.username"></el-input>
            </el-form-item>

            <el-form-item label="身份证号：" prop="useridcard">
              <el-input v-model="regForm.useridcard"></el-input>
            </el-form-item>

            <el-form-item label="电子邮箱" prop="usermail">
              <el-input v-model="regForm.usermail"></el-input>
            </el-form-item>

            <el-form-item label="手机号码" prop="usermob">
              <el-input v-model="regForm.usermob"></el-input>
            </el-form-item>
            <el-form-item label="验证码：" class="item_yzm" prop="uservcode">
              <el-input v-model="regForm.uservcode"></el-input>
              <div class="d_yzm">
                <img :src="codeImg" @click="changeCodeImg()" />
              </div>
            </el-form-item>
            <el-form-item
              label="短信验证码："
              class="item_yzm"
              prop="usermobvcode"
            >
              <el-input v-model="regForm.usermobvcode"></el-input>
              <div class="d_yzm">
                <el-button
                  type="info"
                  class="an_block"
                  :disabled="disabledBtn"
                  @click="sendCode"
                  >{{ text }}</el-button
                >
              </div>
            </el-form-item>
            <el-form-item class="lg_anq1">
              <el-button
                type="danger"
                class="an_r an_block"
                @click="submitForm()"
                >提交注册</el-button
              >
            </el-form-item>
          </el-form>
          <div class="lg_anq2">
            <span class="s_n">
              已有帐号，<router-link to="/login" class="cd_r"
                >立即登录</router-link
              >
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../http/http";
import api from "../http/api";
export default {
  data() {
    // 手机验证
    var validateMobilePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不可为空"));
      } else {
        if (value !== "") {
          var reg = /^1[3456789]\d{9}$/;
          if (!reg.test(value)) {
            callback(new Error("请输入有效的手机号码"));
          }
        }
        callback();
      }
    };
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }, 100);
    };
    return {
      text: "获取验证码",
      timer: 60,
      disabledBtn: false,
      time: null,
      codeImg: "",
      regForm: {
        username: "",
        usermob: "",
        uservcode: "",
        usermobvcode: "",
        useridcard: "",
        usermail: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 10, message: "长度在2到10个字符", trigger: "blur" },
        ],
        useridcard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            min: 15,
            max: 18,
            message: "请输入有效的身份证号",
            trigger: "blur",
          },
          {
            required: true,
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入有效的身份证号",
            trigger: "blur",
          },
        ],
        usermail: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          {
            validator: checkEmail,
            message: "请输入有效的电子邮箱",
            trigger: "blur",
          },
        ],
        usermob: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            validator: validateMobilePhone,
            message: "请输入有效的手机号码",
            trigger: "blur",
          },
        ],
        uservcode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        usermobvcode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    //初始图形验证码
    this.codeImg = this.GLOBAL.posturl + "api/account/validatecode";
  },
  methods: {
    // 获取倒计时
    getSecond(timer) {
      this.disabledBtn = true;
      this.text = this.timer + "s后重新获取";
      this.timer--;
      if (this.timer == 0) {
        clearInterval(this.time);
        this.text = "获取验证码";
        this.timer = 60;
        console.log(this.timer);
        this.disabledBtn = false;
      }
    },
    // 发送短信
    async sendCode() {
      let data = {
        MobilePhone: this.regForm.usermob,
        ValidateCode: this.regForm.uservcode,
      };
      if (data.MobilePhone.length > 0 && data.ValidateCode.length > 0) {
        const res = await http.post(api.apismscode, data);
        if (res.data.Status === 1) {
          this.time = setInterval(() => {
            this.getSecond(60);
          }, 1000);
        } else {
          return this.$message.error(res.data.Message);
        }
      }
    },
    //表单验证
    async submitForm() {
      this.$refs.regForm.validate((valid) => {
        if (valid) {
          let data = {
            MobilePhone: this.regForm.usermob,
            ValidateCode: this.regForm.usermobvcode,
            IdentityCard: this.regForm.useridcard,
            Email: this.regForm.usermail,
            RealName: this.regForm.username,
          };
          http.post(api.apiregister, data).then(
            (res) => {
              if(res.data.Status==1)
               {
                  this.$message.success(res.data.Message);
                  this.$router.push({path:'/login'});
               }
               else{
                 return this.$message.error(res.data.Message);
               }
            },
            (error) => {
             console.log(err);
            }
          );
        } else {
          return false;
        }
      });
    },
    //刷新图形验证码
    changeCodeImg() {
      var num = Math.ceil(Math.random() * 10);
      this.codeImg =
        this.GLOBAL.posturl + "api/account/validatecode?num=" + num;
    },
  },
  created: function () {
    // this.$emit('header', false);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Register.vue